import {createSlice} from '@reduxjs/toolkit';

export const moveInventoryQuantityModalSlice = createSlice({
    name: 'moveInventoryQuantityModal',
    initialState: {
        isModalOpened: false,
        isDragAndDropMovingMode: false,
        inventory: null,
        newInventoryPosition: null,
        warehouseFrom: null,
        warehouseTo: null
    },
    reducers: {
        changeIsMoveInventoryQuantityModalOpened(state, action) {
            state.isModalOpened = action.payload.value;
            state.inventory = action.payload.inventory;
            state.newInventoryPosition = action.payload.inventoryPosition;
        },
        setIsDragAndDropMovingMode(state, action) {
            state.isDragAndDropMovingMode = action.payload;
        },
        setWarehouseFrom(state, action) {
            state.warehouseFrom = action.payload;
        },
        setWarehouseTo(state, action) {
            state.warehouseTo = action.payload;
        },
        cancelMoveInventory(state) {
            state.inventory = null;
            state.warehouseFrom = null;
            state.isModalOpened = false;
            state.isDragAndDropMovingMode = false;
        }
    },
});

export const {
    changeIsMoveInventoryQuantityModalOpened,
    setIsDragAndDropMovingMode,
    setWarehouseFrom,
    setWarehouseTo,
    cancelMoveInventory,
} = moveInventoryQuantityModalSlice.actions;

export default moveInventoryQuantityModalSlice.reducer;
